import { getPublicUrl } from '@shared/configs/configs/config';

export function getInstitutionLogoPath(logoCode?: string) {
  return `${getPublicUrl()}Logo/${logoCode}.png`;
}
